export default "__VITE_ASSET__$7vav3xg__"